import React from "react";

import { copy } from "shared/assets";
import {
  Button,
  Modal,
  APIErrorMessage,
  Message,
  ButtonContainer,
  Loader,
} from "shared/components";
import { Spacer } from "shared/layout";
import { BoldText } from "shared/styles";
import { IAPIState, IStatus, ITheme } from "shared/types";

const { form } = copy;

interface DeleteModalProps {
  type?: string;
  name: string;
  message?: string | null;
  apiMeta?: {
    status: IAPIState;
    error?: any;
  };
  customDeleteCopy?: string;
  customButtonCopy?: string;
  customCancelCopy?: string;
  handleDelete: () => void;
  handleClose: () => void;
  isCheckingPreventDelete?: boolean;
  preventDeleteMessage?: string | JSX.Element;
  error?: string | boolean;
  dataTestId?: string;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
  type,
  name,
  message,
  apiMeta,
  customButtonCopy,
  customDeleteCopy,
  customCancelCopy,
  handleDelete,
  handleClose,
  isCheckingPreventDelete,
  preventDeleteMessage,
  error,
  dataTestId = "delete_modal",
}) => {
  const renderContent = () => {
    if (isCheckingPreventDelete) return <Loader />;

    if (preventDeleteMessage) {
      return (
        <Message status={IStatus.error} hideBackground>
          <Spacer size="m">{preventDeleteMessage}</Spacer>
        </Message>
      );
    }

    return (
      <Spacer size="m">
        <Message hideBackground status={IStatus.warning}>
          {customDeleteCopy ||
            `${copy.deleteModal.message} ${type?.toLowerCase()}`}
          {name && (
            <>
              {" "}
              <BoldText>{name}</BoldText>
            </>
          )}
          {"?"}
          {message && <> {message}</>}
        </Message>
        <ButtonContainer>
          <Button
            status={IStatus.error}
            onClick={handleDelete}
            data-testid="delete_button"
          >
            <Spacer spaceDirection="horizontal" size="xs">
              <span>{customButtonCopy || form.delete}</span>
              {apiMeta?.status === IAPIState.pending && <Loader size="s" />}
            </Spacer>
          </Button>
          <Button
            onClick={handleClose}
            theme={ITheme.secondary}
            data-testid="cancel_delete_button"
          >
            {customCancelCopy || form.cancel}
          </Button>
        </ButtonContainer>
        {(error || apiMeta?.error) && (
          <APIErrorMessage apiErrorMessage={error} apiError={apiMeta?.error} />
        )}
      </Spacer>
    );
  };

  return (
    <Modal dataTestId={dataTestId} handleClose={handleClose}>
      {renderContent()}
    </Modal>
  );
};
